module.exports = __webpack_public_path__ + "img/travel-and-tourism.b9260400.webp";